<template>
  <div>
    <Nav :showMobileSearch="false"/>
    <div class="fav-main">
      <div class="main-box">
         <div class="home-tit sch">
          <div class="t-l">
            <span class="name"> <i class="fav"></i>我的收藏</span>
          </div>
        </div>
           <div class="fav-tap">
        
          <div class="tap">
            <router-link to="/fav/record" active-class="cur"><i class="record"></i>唱片</router-link>
            <a-divider type="vertical" />
            <router-link to="/fav/song" active-class="cur"><i class="song"></i>曲目</router-link>
            <a-divider type="vertical" />
            <router-link to="/fav/mc" active-class="cur"><i class="musician"></i>乐人</router-link>
             <a-divider type="vertical" />
            <router-link to="/fav/org" active-class="cur"><i class="com"></i>{{!isMobile ? '机构团体' : '机构'}}</router-link>
          </div>
        </div>
        <router-view></router-view>
      </div>
    </div>

    <a-modal title="播放，仅剩一步"
             :visible="playLoginvisible"
             :footer="null"
             @cancel="handleCancel">
      <p>您还未登录，暂无播放权限。 点击登录后即可畅听 ：)</p>
      <div class="modal-btn">
        <a href="javascript:" class="cancel" @click="handleCancel">取消</a>
        <a :href="loginHref" class="confirm">去登录</a>
      </div>
    </a-modal>


    <a-modal title="收藏，仅剩一步"
             :visible="sc"
             @ok="handleOk"
             :footer="null"
             @cancel="schandleCancel">
      <p>您还未登录，暂无收藏权限。 点击登录后即可收藏 ：)</p>
      <div class="modal-btn">
        <a href="javascript:" class="cancel" @click="schandleCancel">取消</a>
        <a :href="loginHref" class="confirm" @click="handleOk">去登录</a>
      </div>
    </a-modal>

    
    <a-modal title="该曲目暂无法播放"
             :visible="noqmplay"
             :footer="null"
             @cancel="noqmhandleCancel">
      <p>该曲目暂无法播放，您可以逛逛其他内容</p>
      <div class="modal-btn">
        <a  href="javascript:" class="confirm" @click="noqmhandleCancel">知道了</a>
      </div>
    </a-modal>


    <a-modal title="该唱片暂无法播放"
             :visible="nocpplay"
             :footer="null"
             @cancel="nocphandleCancel">
      <p>该曲目暂无法播放，您可以逛逛其他内容</p>
      <div class="modal-btn">
        <a  href="javascript:" class="confirm" @click="nocphandleCancel">知道了</a>
      </div>
    </a-modal>
    <Footer />
  </div>
</template>

<script>
import Nav from "@/components/nav";
import Footer from "@/components/footer";
import Player from '@/components/player'
const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(
  navigator.userAgent
);
export default {
  components: {
    Nav,
    Footer,
    Player
  },
  data(){
    return {
      loginHref: null,
      // isLogin:true,
      playLoginvisible:false,
      sc:false,
      isMobile,
      noqmplay:false,
      nocpplay:false,
      // isLogin:true,
      playLoginvisible:false,
      sc:false,
      noqmplay:false,
      nocpplay:false,
    }
  },
  mounted() {
    this.loginHref =this.GLOBAL.BASE_LOGIN_URL +window.location.href;
  },
  methods:{
    coll(isFav){
      this.$message.open({
        content: isFav ? "已收藏" : "已取消收藏",
        icon: (
          <img
            style="width:14px;height:14px;margin-right:5px"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEUSURBVHgBpZFNbsIwEIVnvEBZplL/dqUnqHqD3qDpBsyuPUF7g6Q3oCeougOvygm4AtwgOyQiBFsEzDC2CAo/gZA8yYn9xv409kPIaBoE/sLzAiR6UIgzGb2rTie2tZHW9RrzKzH7BDCsKTVIa1aYTsat1pciChnAh121ZROK/5k1xYuXzD/3xrS3oLHW78j8CyUkHb7dGfOv7EIxh1BSAnANYKL1CzD3oYLmRM9K7l6HivIQnxSsVgOoKGaO3WMnzeYUDtMqBpH0brvdR/fYktgHlJQEFbm//Vzb+DbGZe1wJGf/XDNZf9JohIQYFYXcGPOdLnG/Xgi2BzkKOgs7AskF5cJyICdBB7ATkEKysETGuX1rfziAH44aflAAAAAASUVORK5CYII="
          />
        ),
      });
    },
    handleCancel(){
      this.playLoginvisible = false
    },
    schandleCancel(){
      this.sc = false;
    },
    noqmhandleCancel(){
      this.noqmplay = false
    },
    nocphandleCancel(){
      this.nocpplay = false;
    },
    handleOk(){

    },
    showTk(t){
      //console.log(t);
      //未登录播放
      if(t == 1){
        this.playLoginvisible = true;
      }
      //未登录收藏
      if(t == 2){
        this.sc = true;
      }
      //无唱片播放
      if(t == 3){
        this.nocpplay = true;
      }
      //无曲目播放
      if(t == 4){
        this.noqmplay = true;
      }
    },
  }
}
</script>
